/* istanbul ignore file */
export enum PropertyActionTypesEnum {
    SET_PROPERTIES = 'property/set-properties',
    SET_CURRENT_PROPERTY = 'property/set-current',
    SET_CURRENT_PROPERTY_DOCUMENTS = 'property/set-current-documents',
    SET_CURRENT_PROPERTY_CONVERSATION = 'property/set-current-conversation',
    SET_SUPPLY_INVOICES = 'property/set-supply-invoices',
    ADD_SUPPLY_INVOICE = 'property/add-supply-invoice'
}
